import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiRadioModule } from "@webapp/ui/radio/radio.module";
import { RadioGroupWrapperComponent } from "./radio-group-wrapper.component";

@NgModule({
  imports: [CommonModule, FormsModule, LocalizationModule, UiRadioModule],
  declarations: [RadioGroupWrapperComponent],
  exports: [RadioGroupWrapperComponent],
})
export class RadioGroupWrapperModule {}
